<template>
<div
  class="choir"
  :class="{
    'mouth-o': mouthState === 'o',
    'mouth-wide': mouthState === 'wide',
    'mouth-left': mouthState === 'left',
    'mouth-flat': mouthState === 'flat',
    'mouth-right': mouthState === 'right',
    'choir-o': mouthState === 'choiro',
    'choir-wide': mouthState === 'choirwide',
    'choir-flat': mouthState === 'choirflat',
    'text-click-again-3': clickState === '3',
    'text-click-again-6': clickState === '6',
    'text-click-again-10': clickState === '10',
    'text-hide-intro': introState === 'hide'
  }"
>
  <div class="choir__mouth-o"></div>
  <div class="choir__mouth-wide"></div>
  <div class="choir__mouth-flat"></div>
  <div class="choir__mouth-left"></div>
  <div class="choir__mouth-right"></div>
  <div class="choir__choir-o"></div>
  <div class="choir__choir-wide"></div>
  <div class="choir__choir-flat"></div>
  <div class="choir__text-intro">Listen to the song and read the lyrics to answer the question.</div>
  <div class="choir__text-line-one">{{ lineOneText }}</div>
  <div class="choir__text-line-two">{{ lineTwoText }}</div>
  <div class="choir__text-click-again-3" @click="play3()">Click the choir to listen again!</div>
  <div class="choir__text-click-again-6" @click="play6()">Click the choir to listen again!</div>
  <div class="choir__text-click-again-10" @click="play10()">Click the choir to listen again!</div>
</div>
</template>

<script>
import { Howl } from 'howler'

export default {
  name: 'choir',
  data () {
    return {
      mouthState: '',
      mouthTimeCounter: 0,
      mouthInterval: null,
      mouthIntervalPeriod: 100,
      song3: null,
      song6: null,
      song10: null,
      lineOneText: '',
      lineTwoText: '',
      clickState: '',
      introState: '',
    }
  },
  mounted () {
    this.song3= new Howl({
      src: ['audio/stream3song.mp3'],
      html5: true
    })
    this.song6= new Howl({
      src: ['audio/stream6song.mp3'],
      html5: true
    })
    this.song10= new Howl({
      src: ['audio/stream10song.mp3'],
      html5: true
    })
  },
  methods: {
    stop () {
      this.mouthState = ''
      this.mouthTimeCounter = 0
      this.lineOneText = '',
      this.lineTwoText = '',
      this.clickState = '',
      this.introState = '',
      clearInterval(this.mouthInterval)
      this.song3.stop()
      this.song6.stop()
      this.song10.stop()
    },
    play3 () {
      this.song3.play()
      this.mouthState = ''
      this.mouthTimeCounter = 0
      this.introState = 'hide'
      this.clickState = ''
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval(() => {
        if (this.mouthTimeCounter <2000) {
          this.mouthState = 'flat'
          this.lineOneText = 'Steal Away'
        } 
        if (this.mouthTimeCounter >=2000 && this.mouthTimeCounter<3000) {
          this.mouthState = 'o'
        } 
        if (this.mouthTimeCounter >=3000 && this.mouthTimeCounter<4000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=4000 && this.mouthTimeCounter<6000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=6000 && this.mouthTimeCounter<7000) {
          this.mouthState = 'right'
          this.lineOneText = 'Steal Away,'
          this.lineTwoText = 'Steal Away'
        } 
        if (this.mouthTimeCounter >=7000 && this.mouthTimeCounter<9000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=9000 && this.mouthTimeCounter<10000) {
          this.mouthState = 'o'
        } 
        if (this.mouthTimeCounter >=10000 && this.mouthTimeCounter<11000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=11000 && this.mouthTimeCounter<11000) {
          this.mouthState = 'right'
        } 
        if (this.mouthTimeCounter >=11000 && this.mouthTimeCounter<13000) {
          this.mouthState = 'flat'
          this.lineOneText = 'Steal Away'
          this.lineTwoText = ''
        } 
        if (this.mouthTimeCounter >=13000 && this.mouthTimeCounter<14000) {
          this.mouthState = 'o'
        } 
        if (this.mouthTimeCounter >=14000 && this.mouthTimeCounter<15000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=15000 && this.mouthTimeCounter<16000) {
          this.mouthState = 'o'
          this.lineTwoText = 'to Jesus'
        } 
        if (this.mouthTimeCounter >=16000 && this.mouthTimeCounter<18000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=18000 && this.mouthTimeCounter<19000) {
          this.mouthState = 'right'
        } //HERE
        if (this.mouthTimeCounter >=19000 && this.mouthTimeCounter<20000) {
          this.mouthState = 'wide'
          this.lineOneText = 'Steal Away'
          this.lineTwoText = ''
        } 
        if (this.mouthTimeCounter >=20000 && this.mouthTimeCounter<21000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=21000 && this.mouthTimeCounter<22000) {
          this.mouthState = 'right'
        } 
        if (this.mouthTimeCounter >=22000 && this.mouthTimeCounter<23000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=23000 && this.mouthTimeCounter<24000) {
          this.mouthState = 'o'
        }
        if (this.mouthTimeCounter >=24000 && this.mouthTimeCounter<25000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=25000 && this.mouthTimeCounter<26000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=26000 && this.mouthTimeCounter<28000) {
          this.mouthState = 'o'
          this.lineTwoText = 'home'
        }
        if (this.mouthTimeCounter >=28000 && this.mouthTimeCounter<29000) {
          this.mouthState = ''
        }
        if (this.mouthTimeCounter >=29000 && this.mouthTimeCounter<30000) {
          this.mouthState = 'o'
          this.lineOneText = 'I ain\'t got long'
          this.lineTwoText = ''
        }
        if (this.mouthTimeCounter >=30000 && this.mouthTimeCounter<31000) {
          this.mouthState = 'right'
        }         
        if (this.mouthTimeCounter >=31000 && this.mouthTimeCounter<32000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=32000 && this.mouthTimeCounter<33000) {
          this.mouthState = 'flat'
        } 
        if (this.mouthTimeCounter >=33000 && this.mouthTimeCounter<34000) {
          this.mouthState = 'o'
          this.lineTwoText = 'to stay here'
        }
        if (this.mouthTimeCounter >=34000 && this.mouthTimeCounter<35000) {
          this.mouthState = 'flat'
        }
        if (this.mouthTimeCounter >=35000 && this.mouthTimeCounter<36000) {
          this.mouthState = 'o'
        }
        if (this.mouthTimeCounter >=36000 && this.mouthTimeCounter<37000) {
          this.mouthState = 'flat'
        }
        if (this.mouthTimeCounter >37000){
          this.mouthState = ''
          this.lineOneText = ''
          this.lineTwoText = ''
          this.clickState = '3'
        }
        this.mouthTimeCounter += this.mouthIntervalPeriod
      }, this.mouthIntervalPeriod)
    },
    play6 () {
      this.song6.play()
      this.mouthState = ''
      this.mouthTimeCounter = 0
      this.introState = 'hide'
      this.clickState = ''
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval(() => {
        if (this.mouthTimeCounter <400) {
          this.lineOneText = 'Follow the Star'
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=400 && this.mouthTimeCounter<800) {
          this.mouthState = 'choiro'
        } 
        if (this.mouthTimeCounter >=800 && this.mouthTimeCounter<1200) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=1200 && this.mouthTimeCounter<1600) {
          this.mouthState = 'choirwide'
        } 
        if (this.mouthTimeCounter >=1600 && this.mouthTimeCounter<2000) {
          this.lineOneText = ''
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=2000 && this.mouthTimeCounter<2500) {
          this.lineOneText = 'Follow the Star'
          this.mouthState = 'choiro'
        } 
        if (this.mouthTimeCounter >=2500 && this.mouthTimeCounter<3000) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=3000 && this.mouthTimeCounter<3500) {
          this.mouthState = 'choirwide'
        } 
        if (this.mouthTimeCounter >=4000 && this.mouthTimeCounter<4500) {
          this.lineOneText = ''
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=4500 && this.mouthTimeCounter<5000) {
          this.lineOneText = 'Follow the Star'
          this.mouthState = 'choiro'
        } 
        if (this.mouthTimeCounter >=5000 && this.mouthTimeCounter<5500) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=5500 && this.mouthTimeCounter<6000) {
          this.mouthState = 'choirwide'
        } 
        if (this.mouthTimeCounter >=6000 && this.mouthTimeCounter<6700) {
          this.lineOneText = 'to Bethlehem'
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=6700 && this.mouthTimeCounter<6800) {
          this.mouthState = ''
        } 
        if (this.mouthTimeCounter >=6800 && this.mouthTimeCounter<7500) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=7500 && this.mouthTimeCounter<7600) {
          this.mouthState = ''
        } 
        if (this.mouthTimeCounter >=7600 && this.mouthTimeCounter<8300) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=8300 && this.mouthTimeCounter<8400) {
          this.mouthState = ''
        } 
        if (this.mouthTimeCounter >=8400 && this.mouthTimeCounter<9000) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=9000 && this.mouthTimeCounter<9500) {
          this.lineOneText = 'What did they'
          this.lineTwoText = 'see children?'
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=9500 && this.mouthTimeCounter<9600) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=9600 && this.mouthTimeCounter<10500) {
          this.mouthState = 'right'
        }  
        if (this.mouthTimeCounter >=10500 && this.mouthTimeCounter<11000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=11000 && this.mouthTimeCounter<12000) {
          this.lineOneText = 'What did'
          this.lineTwoText = 'they see?'
          this.mouthState = 'right'
        }
        if (this.mouthTimeCounter >=12000 && this.mouthTimeCounter<13000) {
          this.mouthState = 'flat'
        }  
        if (this.mouthTimeCounter >=13000 && this.mouthTimeCounter<13500) {
          this.lineOneText = 'They saw'
          this.lineTwoText = 'baby Jesus'
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=14000 && this.mouthTimeCounter<14500) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=14500 && this.mouthTimeCounter<15000) {
          this.mouthState = 'choiro'
        }  
        if (this.mouthTimeCounter >=15000 && this.mouthTimeCounter<15500) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=15500 && this.mouthTimeCounter<16000) {
          this.lineOneText = 'the newborn'
          this.lineTwoText = 'King'
          this.mouthState = 'choiro'
        }
        if (this.mouthTimeCounter >=16000 && this.mouthTimeCounter<16500) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=16500 && this.mouthTimeCounter<17000) {
          this.mouthState = 'choirwide'
        }  
        if (this.mouthTimeCounter >=17000 && this.mouthTimeCounter<18000) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=18000 && this.mouthTimeCounter<18100) {
          this.lineOneText = 'They saw'
          this.lineTwoText = 'baby Jesus'
          this.mouthState = ''
        }
        if (this.mouthTimeCounter >=18100 && this.mouthTimeCounter<18900) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=18900 && this.mouthTimeCounter<19000) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=19000 && this.mouthTimeCounter<19800) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=19800 && this.mouthTimeCounter<19900) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=19900 && this.mouthTimeCounter<20500) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=20500 && this.mouthTimeCounter<21800) {
          this.lineOneText = 'the newborn'
          this.lineTwoText = 'King'
          this.mouthState = 'choiro'
        }
        if (this.mouthTimeCounter >=21800 && this.mouthTimeCounter<23000) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=23000 && this.mouthTimeCounter<23500) {
          this.lineOneText = 'What did they'
          this.lineTwoText = 'do children?'
          this.mouthState = 'wide'
        }
        if (this.mouthTimeCounter >=23500 && this.mouthTimeCounter<23600) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=23600 && this.mouthTimeCounter<24500) {
          this.mouthState = 'right'
        }  
        if (this.mouthTimeCounter >=24500 && this.mouthTimeCounter<25000) {
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=25000 && this.mouthTimeCounter<26000) {
          this.lineOneText = 'What did'
          this.lineTwoText = 'they do?'
          this.mouthState = 'right'
        }
        if (this.mouthTimeCounter >=26000 && this.mouthTimeCounter<27000) {
          this.mouthState = 'flat'
        }  
        if (this.mouthTimeCounter >=27000 && this.mouthTimeCounter<27600) {
          this.lineOneText = 'They shouted'
          this.lineTwoText = ''
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=27600 && this.mouthTimeCounter<27700) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=27700 && this.mouthTimeCounter<28400) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=28400 && this.mouthTimeCounter<28500) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=28500 && this.mouthTimeCounter<29500) {
          this.lineOneText = 'Glory Hallelujah'
          this.lineTwoText = ''
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=29500 && this.mouthTimeCounter<30000) {
          this.mouthState = 'choiro'
        }  
        if (this.mouthTimeCounter >=30000 && this.mouthTimeCounter<30500) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=30500 && this.mouthTimeCounter<31000) {
          this.mouthState = 'choiro'
        }  
        if (this.mouthTimeCounter >=31000 && this.mouthTimeCounter<32000) {
          this.lineOneText = 'They shouted'
          this.lineTwoText = ''
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=32000 && this.mouthTimeCounter<33000) {
          this.mouthState = 'choirwide'
        }  
        if (this.mouthTimeCounter >=33000 && this.mouthTimeCounter<33700) {
          this.lineOneText = 'Glory Hallelujah'
          this.lineTwoText = ''
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=33700 && this.mouthTimeCounter<33800) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=33800 && this.mouthTimeCounter<34400) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >=34400 && this.mouthTimeCounter<34500) {
          this.mouthState = ''
        }  
        if (this.mouthTimeCounter >=34500 && this.mouthTimeCounter<36000) {
          this.mouthState = 'choirflat'
        }  
        if (this.mouthTimeCounter >36000){
          this.mouthState = ''
          this.lineOneText = ''
          this.lineTwoText = ''
          this.clickState = '6'
        }
        this.mouthTimeCounter += this.mouthIntervalPeriod
      }, this.mouthIntervalPeriod)
    },
    play10 () {
      this.song10.play()
      this.mouthState = ''
      this.mouthTimeCounter = 0
      this.introState = 'hide'
      this.clickState = ''
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval(() => {
        if (this.mouthTimeCounter <500) {
          this.lineOneText = 'Way down'
          this.mouthState = 'o'
        } 
        if (this.mouthTimeCounter >=500 && this.mouthTimeCounter<1500) {
          this.mouthState = 'wide'
        }
        if (this.mouthTimeCounter >=1500 && this.mouthTimeCounter<3000) {
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=3000 && this.mouthTimeCounter<4000) {
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=4000 && this.mouthTimeCounter<4500) {
          this.lineOneText = ''
          this.mouthState = 'o'
        } 
        if (this.mouthTimeCounter >=4500 && this.mouthTimeCounter<5500) {
          this.lineOneText = 'Way down'
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=5500 && this.mouthTimeCounter<6500) {
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=6500 && this.mouthTimeCounter<7500) {
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=7500 && this.mouthTimeCounter<8500) {
          this.lineOneText = 'in Egypt land'
          this.mouthState = 'choirwide'
        } 
        if (this.mouthTimeCounter >=8500 && this.mouthTimeCounter<9000) {
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=9000 && this.mouthTimeCounter<9500) {
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=9500 && this.mouthTimeCounter<10000) {
          this.mouthState = 'o'
        }
        if (this.mouthTimeCounter >=10000 && this.mouthTimeCounter<11500) {
          this.lineOneText = 'They sold'
          this.lineTwoText = 'my mother'
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=11500 && this.mouthTimeCounter<13000) {
          this.mouthState = 'right'
        }
        if (this.mouthTimeCounter >=13000 && this.mouthTimeCounter<14500) {
          this.lineOneText = 'She was'
          this.lineTwoText = 'way down'
          this.mouthState = 'wide'
        }
        if (this.mouthTimeCounter >=14500 && this.mouthTimeCounter<16000) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=16000 && this.mouthTimeCounter<17000) {
          this.lineOneText = 'in Egypt land'
          this.lineTwoText = ''
          this.mouthState = 'choirwide'
        } 
        if (this.mouthTimeCounter >=17000 && this.mouthTimeCounter<18000) {
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=18000 && this.mouthTimeCounter<20000) {
          this.lineOneText = 'They sold'
          this.lineTwoText = 'my father'
          this.mouthState = 'wide'
        }
        if (this.mouthTimeCounter >=20000 && this.mouthTimeCounter<22000) {
          this.mouthState = 'o'
        }        
        if (this.mouthTimeCounter >=22000 && this.mouthTimeCounter<23000) {
          this.lineOneText = 'He was'
          this.lineTwoText = 'way down'
          this.mouthState = 'wide'
        } 
        if (this.mouthTimeCounter >=23000 && this.mouthTimeCounter<24000) {
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >=24000 && this.mouthTimeCounter<25000) {
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=25000 && this.mouthTimeCounter<26000) {
          this.lineOneText = 'in Egypt land'
          this.lineTwoText = ''
          this.mouthState = 'choirflat'
        } 
        if (this.mouthTimeCounter >=26000 && this.mouthTimeCounter<27000) {
          this.mouthState = 'choirwide'
        }
        if (this.mouthTimeCounter >=27000 && this.mouthTimeCounter<28000) {
          this.mouthState = 'choirflat'
        }
        if (this.mouthTimeCounter >28000){
          this.mouthState = ''
          this.lineOneText = ''
          this.lineTwoText = ''
          this.clickState = '10'
        }
        this.mouthTimeCounter += this.mouthIntervalPeriod
      }, this.mouthIntervalPeriod)
    }
  },
  beforeDestroy () {
    clearInterval(this.mouthInterval)
  }
}
</script>

<style lang="scss">
.choir {
  position: relative;
  width: fluid(170px);
  height: fluid(228px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url('~@/assets/img/choir.png');
  transform-origin: 0% 0%;
  z-index: -1;
  &__mouth-o {
    display: none;
    position: absolute;
    top: fluid(12px);
    left: fluid(-8px);
    width: fluid(200px);
    height: fluid(200px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/mouth-o.png');
  }
  &__mouth-wide {
    display: none;
    position: absolute;
    top: fluid(12px);
    left: fluid(-8px);
    width: fluid(200px);
    height: fluid(200px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/mouth-wide.png');
  }
  &__mouth-flat {
    display: none;
    position: absolute;
    top: fluid(12px);
    left: fluid(-8px);
    width: fluid(200px);
    height: fluid(200px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/mouth-flat.png');
  }
  &__mouth-left {
    display: none;
    position: absolute;
    top: fluid(12px);
    left: fluid(-8px);
    width: fluid(200px);
    height: fluid(200px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/mouth-left.png');
  }
  &__mouth-right {
    display: none;
    position: absolute;
    top: fluid(12px);
    left: fluid(-8px);
    width: fluid(200px);
    height: fluid(200px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/mouth-right.png');
  }
  &__choir-o {
    display: none;
    position: absolute;
    top: fluid(18px);
    left: fluid(-4px);
    width: fluid(180px);
    height: fluid(190px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/choir-o.png');
  }
  &__choir-wide {
    display: none;
    position: absolute;
    top: fluid(18px);
    left: fluid(-4px);
    width: fluid(180px);
    height: fluid(190px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/choir-wide.png');
  }
  &__choir-flat {
    display: none;
    position: absolute;
    top: fluid(18px);
    left: fluid(-4px);
    width: fluid(180px);
    height: fluid(190px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/choir-flat.png');
  }
  &__text-line-one {
    display: block;
    position: absolute;
    top: fluid(215px);
    left: fluid(10px);
    width: fluid(150px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(20px);
    line-height: 1.2;
    color: #FFF;
    text-align: center;
  }
  &__text-line-two {
    display: block;
    position: absolute;
    top: fluid(248px);
    left: fluid(10px);
    width: fluid(150px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(20px);
    line-height: 1.2;
    color: #FFF;
    text-align: center;
  }
  &__text-click-again-3 {
    display: none;
    position: absolute;
    top: fluid(20px);
    left: fluid(10px);
    width: fluid(150px);
    padding: fluid(200px) fluid(20px) 0 fluid(20px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(16px);
    line-height: 1.2;
    &:hover {
      color: #FFF;
      cursor: pointer;
    }
  }
  &__text-click-again-6 {
    display: none;
    position: absolute;
    top: fluid(20px);
    left: fluid(10px);
    width: fluid(150px);
    padding: fluid(200px) fluid(20px) 0 fluid(20px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(16px);
    line-height: 1.2;
    &:hover {
      color: #FFF;
      cursor: pointer;
    }
  }
  &__text-click-again-10 {
    display: none;
    position: absolute;
    top: fluid(20px);
    left: fluid(10px);
    width: fluid(150px);
    padding: fluid(200px) fluid(20px) 0 fluid(20px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(16px);
    line-height: 1.2;
    &:hover {
      color: #FFF;
      cursor: pointer;
    }
  }
  &__text-intro {
    display: block;
    position: absolute;
    top: fluid(220px);
    left: fluid(-15px);
    width: fluid(200px);
    padding: 0 fluid(10px) 0 fluid(10px);
    font-family: $decorative;
    font-weight: bold;
    font-size: fluid(16px);
    line-height: 1.2;
    text-align: center;
  }
  &.text-hide-intro {
    .choir {
      &__text-intro {
        display: none;
      }
    }
  }
  &.text-click-again-3 {
    .choir {
      &__text-click-again-3 {
        display: block;
      }
    }
  }
  &.text-click-again-6 {
    .choir {
      &__text-click-again-6 {
        display: block;
      }
    }
  }
  &.text-click-again-10 {
    .choir {
      &__text-click-again-10 {
        display: block;
      }
    }
  }
  &.mouth-o {
    .choir {
      &__mouth-o {
        display: block;
      }
    }
  }
  &.mouth-wide {
    .choir {
      &__mouth-wide {
        display: block;
      }
    }
  }
  &.mouth-flat {
    .choir {
      &__mouth-flat {
        display: block;
      }
    }
  }
  &.mouth-left {
    .choir {
      &__mouth-left {
        display: block;
      }
    }
  }
  &.mouth-right {
    .choir {
      &__mouth-right {
        display: block;
      }
    }
  }
  &.choir-o {
    .choir {
      &__choir-o {
        display: block;
      }
    }
  }
  &.choir-wide {
    .choir {
      &__choir-wide {
        display: block;
      }
    }
  }
  &.choir-flat {
    .choir {
      &__choir-flat {
        display: block;
      }
    }
  }
}
</style>